import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const SHOW = 4;

export function CampaignCourses({ campaign }) {
  const [courses, setCourses] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false); setCourses([]);
    if (!campaign) return;
    axios.get(`${API}/api/vouchers/issuance/campaign-courses`, { params: { campaign }, withCredentials: true })
      .then(r => setCourses(r.data?.courses || []))
      .catch(() => setCourses([]));
  }, [campaign]);

  if (!courses.length) return null;
  const shown = open ? courses : courses.slice(0, SHOW);
  return (
    <div data-testid="voucher-campaign-courses" style={{ fontSize: 12, color: '#475569', margin: '-4px 0 14px', lineHeight: 1.6 }}>
      <strong style={{ color: '#0f172a' }}>Campaign courses ({courses.length}):</strong>{' '}
      {shown.join(' · ')}
      {courses.length > SHOW && (
        <button onClick={() => setOpen(o => !o)} data-testid="voucher-campaign-courses-toggle"
          style={{ marginLeft: 6, background: 'none', border: 'none', color: '#4338ca', fontWeight: 600, cursor: 'pointer', fontSize: 12 }}>
          {open ? 'Show less' : `+${courses.length - SHOW} more`}
        </button>
      )}
    </div>
  );
}
